import React, { useCallback, useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import axios from "axios";
import { FaCheck, FaFileAlt, FaTimes } from "react-icons/fa";
import myToast from "../Utils/MyToast";
import SessionManager from "../Utils/SessionManager";
import "../css/Admin_css/admin-customize.css";

const API_BASE = () =>
  `${process.env.REACT_APP_SERVER_NAME}${process.env.REACT_APP_TARGET_DIR}`;

const PAPER_TYPES = [
  { value: "Written", code: "1" },
  { value: "Oral", code: "2" },
  { value: "Theory", code: "3" },
  { value: "Practical", code: "4" },
  { value: "Project", code: "5" },
  { value: "Test", code: "6" },
  { value: "PT", code: "7" },
  { value: "NB", code: "8" },
  { value: "SE", code: "9" },
  { value: "SA", code: "10" },
  { value: "(W)", code: "11" },
  { value: "(O)", code: "12" },
  { value: "(P)", code: "13" },
  { value: "(T)", code: "14" },
  { value: "(NB)", code: "15" },
  { value: "(SE)", code: "16" },
  { value: "(SA)", code: "17" },
  { value: "(PT)", code: "18" },
  { value: "(TEST)", code: "19" },
  { value: "(TH)", code: "20" },
];

const DIALOG_STYLES = `
  .modal.show { display: block !important; opacity: 1 !important; }
  .modal.fade.show { opacity: 1 !important; }
  .mdl-add-paper-dialog.modal-dialog {
    z-index: 1050 !important;
    position: relative;
    margin: 0.45rem auto 1rem;
    max-width: 720px;
  }
  .mdl-add-paper-dialog.modal-dialog.modal-dialog-centered {
    min-height: calc(100% - 1rem);
  }
  .modal-backdrop { z-index: 1040 !important; }
  .modal-backdrop.show { opacity: 0.5 !important; }
  .mdl-add-paper-dialog .modal-content {
    z-index: 1051 !important;
    position: relative;
    border-radius: 16px;
    overflow: hidden;
    border: 2px solid rgba(179, 229, 252, 0.55);
    box-shadow: 0 12px 28px rgba(2, 136, 209, 0.14);
    background: #fff;
  }
  .mdl-add-paper-dialog .modal-header {
    border: none;
    padding: 12px 16px;
    background: linear-gradient(135deg, #03a9f4 0%, #0288d1 55%, #01579b 100%);
  }
  .mdl-add-paper-dialog .modal-header .close {
    color: #fff;
    opacity: 0.92;
    text-shadow: none;
    font-size: 1.35rem;
    font-weight: 400;
    padding: 0.35rem 0.55rem;
  }
  .mdl-add-paper-dialog .modal-body {
    padding: 12px 14px 10px;
    background: linear-gradient(180deg, #f7fcff 0%, #ffffff 42%);
  }
  .mdl-add-paper-dialog .modal-footer {
    border-top: 1px solid #e1f5fe;
    padding: 10px 14px;
    background: #f0f9ff;
    display: flex;
    justify-content: flex-end;
    gap: 8px;
  }
  .map-title {
    display: flex;
    align-items: flex-start;
    gap: 10px;
    margin: 0;
    color: #fff;
    width: 100%;
    padding-right: 18px;
  }
  .map-title__icon {
    width: 34px;
    height: 34px;
    border-radius: 10px;
    flex-shrink: 0;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    background: rgba(255,255,255,0.18);
    border: 1px solid rgba(255,255,255,0.35);
    font-size: 15px;
  }
  .map-title__main { font-size: 16px; font-weight: 800; line-height: 1.2; }
  .map-title__sub {
    margin-top: 2px;
    font-size: 11px;
    font-weight: 500;
    color: rgba(255,255,255,0.88);
  }
  .map-meta {
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
    margin-bottom: 10px;
  }
  .map-pill {
    display: inline-flex;
    align-items: center;
    gap: 5px;
    min-height: 26px;
    padding: 3px 10px;
    border-radius: 999px;
    border: 1px solid #b3e5fc;
    background: #e1f5fe;
    color: #01579b;
    font-size: 11px;
    font-weight: 700;
  }
  .map-form {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 10px;
    padding: 10px;
    border-radius: 10px;
    border: 2px solid rgba(179, 229, 252, 0.65);
    background: #fff;
  }
  .map-field { display: flex; flex-direction: column; gap: 4px; }
  .map-field--full { grid-column: 1 / -1; }
  .map-field label {
    margin: 0;
    font-size: 10px;
    font-weight: 800;
    color: #0277bd;
    text-transform: uppercase;
    letter-spacing: 0.03em;
  }
  .map-field input,
  .map-field select {
    min-height: 38px;
    border-radius: 8px;
    border: 2px solid rgba(179, 229, 252, 0.75);
    padding: 6px 10px;
    font-size: 13px;
    font-weight: 600;
    color: #37474f;
    background: #fff;
    outline: none;
  }
  .map-field input:focus,
  .map-field select:focus {
    border-color: #4fc3f7;
  }
  .map-marking {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
  }
  .map-marking__chip {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    min-height: 34px;
    padding: 4px 12px;
    border-radius: 999px;
    border: 2px solid rgba(179, 229, 252, 0.75);
    background: #fff;
    color: #455a64;
    font-size: 12px;
    font-weight: 700;
    cursor: pointer;
  }
  .map-marking__chip.is-active {
    border-color: #0288d1;
    background: #e1f5fe;
    color: #01579b;
  }
  .map-btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    min-height: 36px;
    padding: 6px 14px;
    border-radius: 8px;
    font-size: 13px;
    font-weight: 800;
    border: 2px solid transparent;
    cursor: pointer;
  }
  .map-btn:disabled { opacity: 0.55; cursor: not-allowed; }
  .map-btn--ghost {
    background: #fff;
    border-color: #b3e5fc;
    color: #0277bd;
  }
  .map-btn--ghost:hover:not(:disabled) { background: #e1f5fe; }
  .map-btn--primary {
    background: linear-gradient(135deg, #03a9f4 0%, #0288d1 100%);
    border-color: #0288d1;
    color: #fff;
  }
  @media (max-width: 640px) {
    .map-form { grid-template-columns: 1fr; }
  }
`;

const MdlAddPaper = ({
  actionClose,
  actionAdd,
  exam_id,
  exam_name,
  session_id,
  class_id,
  section_id,
  subject_id,
  subject_name,
  class_section_name,
}) => {
  const [loading, setLoading] = useState(false);
  const [paperName, setPaperName] = useState(subject_name || "");
  const [isMarkSystem, setIsMarkSystem] = useState("1");
  const [maxMarks, setMaxMarks] = useState("");
  const [maxGrade, setMaxGrade] = useState("");
  const [paperType, setPaperType] = useState("");
  const [paperCode, setPaperCode] = useState("0");

  useEffect(() => {
    const styleTag = document.createElement("style");
    styleTag.setAttribute("data-mdl-add-paper", "1");
    styleTag.textContent = DIALOG_STYLES;
    document.head.appendChild(styleTag);
    return () => {
      if (styleTag.parentNode) styleTag.parentNode.removeChild(styleTag);
    };
  }, []);

  useEffect(() => {
    setPaperName(subject_name || "");
  }, [subject_name]);

  //Created By Cursor
  const handleClose = useCallback(() => {
    if (loading) return;
    actionClose();
  }, [actionClose, loading]);

  //Created By Cursor
  const handlePaperTypeChange = useCallback((e) => {
    const value = e.target.value;
    const option = e.target.options[e.target.selectedIndex];
    setPaperType(value);
    setPaperCode(option?.dataset?.paper_code || "0");
  }, []);

  //Created By Cursor
  const handleSubmit = useCallback(async () => {
    if (!paperName?.trim()) {
      myToast.notify_error("Enter Valid Paper Name!");
      return;
    }
    if (!paperCode || paperCode === "0") {
      myToast.notify_error("Select Paper Type !");
      return;
    }
    if (isMarkSystem === "1" && !maxMarks) {
      myToast.notify_error("Enter Max mark !");
      return;
    }
    if (isMarkSystem !== "1" && !maxGrade) {
      myToast.notify_error("Enter Max grade !");
      return;
    }

    setLoading(true);
    try {
      const schoolCode = SessionManager.getSchoolCode();
      const staffId = SessionManager.getStaffDetails()?.staff_id;
      const response = await axios.get(`${API_BASE()}AddNewExamPaper.php`, {
        params: {
          school_code: schoolCode,
          staff_id: staffId,
          exam_id,
          session_id,
          exam_name,
          class_id,
          section_id,
          subject_id,
          paper_name: paperName.trim(),
          is_mark_system: isMarkSystem,
          is_grade_system: isMarkSystem === "1" ? "0" : "1",
          max_mark: maxMarks || " ",
          max_grade: maxGrade || " ",
          paper_type: paperType,
          paper_code: paperCode,
        },
      });

      if (response.data?.api_status === "OK") {
        myToast.notify_success("Paper Added successfully!");
        actionAdd();
      } else {
        myToast.notify_warning(
          response.data?.api_remark || "Failed to add paper. Please try again."
        );
      }
    } catch (error) {
      console.error("Add paper error:", error);
      myToast.notify_error("An error occurred while adding the paper.");
    } finally {
      setLoading(false);
    }
  }, [
    actionAdd,
    class_id,
    exam_id,
    exam_name,
    isMarkSystem,
    maxGrade,
    maxMarks,
    paperCode,
    paperName,
    paperType,
    section_id,
    session_id,
    subject_id,
  ]);

  return (
    <Modal
      show
      onHide={handleClose}
      animation={false}
      centered
      dialogClassName="mdl-add-paper-dialog"
      aria-labelledby="mdl-add-paper-title"
    >
      <Modal.Header closeButton={!loading}>
        <div className="map-title" id="mdl-add-paper-title">
          <span className="map-title__icon" aria-hidden>
            <FaFileAlt />
          </span>
          <div>
            <div className="map-title__main">Create Exam Paper</div>
            <div className="map-title__sub">
              {subject_name || "Subject"} · {class_section_name || "Class"}
            </div>
          </div>
        </div>
      </Modal.Header>

      <Modal.Body>
        <div className="map-meta">
          <span className="map-pill">
            Class: <strong>{class_section_name || "—"}</strong>
          </span>
          <span className="map-pill">
            Subject: <strong>{subject_name || "—"}</strong>
          </span>
        </div>

        <div className="map-form">
          <div className="map-field">
            <label htmlFor="map-paper-name">Exam Paper Name</label>
            <input
              id="map-paper-name"
              type="text"
              value={paperName}
              onChange={(e) => setPaperName(e.target.value)}
              placeholder="Enter paper name"
              disabled={loading}
            />
          </div>

          <div className="map-field">
            <label htmlFor="map-paper-type">Paper Type</label>
            <select
              id="map-paper-type"
              value={paperType}
              onChange={handlePaperTypeChange}
              disabled={loading}
            >
              <option value="">Select Paper</option>
              {PAPER_TYPES.map((type) => (
                <option
                  key={type.code}
                  value={type.value}
                  data-paper_code={type.code}
                >
                  {type.value}
                </option>
              ))}
            </select>
          </div>

          <div className="map-field map-field--full">
            <label>Marking System</label>
            <div className="map-marking" role="group" aria-label="Marking system">
              <button
                type="button"
                className={`map-marking__chip${
                  isMarkSystem === "1" ? " is-active" : ""
                }`}
                onClick={() => setIsMarkSystem("1")}
                disabled={loading}
              >
                Marks System
              </button>
              <button
                type="button"
                className={`map-marking__chip${
                  isMarkSystem !== "1" ? " is-active" : ""
                }`}
                onClick={() => setIsMarkSystem("0")}
                disabled={loading}
              >
                Grade System
              </button>
            </div>
          </div>

          <div className="map-field map-field--full">
            <label htmlFor="map-max-value">
              {isMarkSystem === "1" ? "Max Marks" : "Max Grade"}
            </label>
            {isMarkSystem === "1" ? (
              <input
                id="map-max-value"
                type="text"
                value={maxMarks}
                onChange={(e) => setMaxMarks(e.target.value)}
                placeholder="Enter max marks"
                disabled={loading}
              />
            ) : (
              <input
                id="map-max-value"
                type="text"
                value={maxGrade}
                onChange={(e) => setMaxGrade(e.target.value)}
                placeholder="Enter max grade"
                disabled={loading}
              />
            )}
          </div>
        </div>
      </Modal.Body>

      <Modal.Footer>
        <button
          type="button"
          className="map-btn map-btn--ghost"
          onClick={handleClose}
          disabled={loading}
        >
          <FaTimes aria-hidden /> Close
        </button>
        <button
          type="button"
          className="map-btn map-btn--primary"
          onClick={handleSubmit}
          disabled={loading}
        >
          <FaCheck aria-hidden />
          {loading ? "Saving…" : "Submit"}
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default MdlAddPaper;
